<!-- @format -->
<industries>
  <style>
    ul.checkbox_list {
      display: flex;
      flex-wrap: wrap;
    }
  </style>

  <div class="box_flex03 margin-spacing-4_bottom">
    <p class="heading-04">業種・業界を検索する</p>
    <div class="box_w50 margin-spacing-2_left margin-spacing-2_right">
      <input
        class="text_input"
        type="text"
        name="searchWord"
        autocomplete="off"
        placeholder="業種・業界を入力"
      />
    </div>
    <div
      class="button button-secondary js-modal-open"
      type="button"
      value="検索"
      onclick="{ onSearchIndustries }"
    >
      検索
    </div>
  </div>

  <div class="container_accordion" each="{ group in props.master }">
    <div class="accordion_heading is-hide" data-group="{ group.id }">
      <div class="checkbox_wrap">
        <input
          type="checkbox"
          id="group_id_{ group.id }"
          class="checkbox-input"
          value="{ group.id }"
          onclick="{ onCheckGroup }"
        />
        <label for="group_id_{ group.id }" class="checkbox-parts">
          { group.name }
        </label>
      </div>
      <div class="js-accordion"></div>
    </div>
    <!--/.accordion_heading-->

    <div class="accordion_body" data-group="{ group.id }" style="display: none">
      <ul class="checkbox_list margin-spacing-1_top">
        <template
          each="{ industry in group.list }"
          if="{industry.type=='check'}"
        >
          <li class="checkbox_list-item">
            <input
              type="checkbox"
              name="industry_id_{ industry.id }"
              value="{ industry.id }"
              checked="{ props.data.isChecked(industry.id) }"
              id="industry_id_{ industry.id }"
              class="checkbox-input media-publication"
              onclick="{ onCheckIndustry }"
            />
            <label for="industry_id_{ industry.id }" class="checkbox-parts">
              { industry.name }
            </label>
          </li>
        </template>
      </ul>
      <template
        each="{ industry in group.list }"
        if="{industry.type=='textarea'}"
      >
        <ul class="checkbox_list">
          <li class="checkbox_list-item">
            <input
              type="checkbox"
              name="industry_id_{ industry.id }"
              value="{ industry.id }"
              checked="{ props.data.isChecked(industry.id) }"
              id="industry_id_{ industry.id }"
              class="checkbox-input js-check_skill-other"
              onclick="{ onCheckIndustry }"
            />
            <label for="industry_id_{ industry.id }" class="checkbox-parts">
              { industry.name }
            </label>
          </li>
        </ul>
        <div class="box_w100">
          <textarea
            class="textarea_input"
            value="{ props.data.getMemo(industry.id) }"
            oninput="{ e => onTextarea(e, industry.id)}"
            disabled="{ !props.data.isChecked(industry.id) }"
          ></textarea>
        </div>
        <div if="{ props.errors[industry.id] }" class="error">
          { props.errors[industry.id] }
        </div>
      </template>
    </div>
    <!--/.accordion_body-->
  </div>

  <search-modal
    id="industries-modal"
    is-open="{ state.searchModalIsOpen }"
    on-close="{ e => update({searchModalIsOpen: false}) }"
    data="{ props.data }"
    errors="{{}}"
    groups="{ state.groups }"
    on-check="{ onCheckIndustry }"
    on-submit="{ onSubmit }"
    caption="業界・業種"
  ></search-modal>

  <script>
    import di from "dependeny-injection";
    import { IndustryMaster } from "@model/skillsheet/worker-history.js";
    import modal from "@tags/modal/search-modal.riot";

    export default {
      components: {
        "search-modal": modal,
      },
      state: {
        searchModalIsOpen: false,
        groups: [],
      },
      onMounted(props, state) {
        window.$(this.$('[name="searchWord"]')).autocomplete({
          source: (request, response) => {
            const { groups, list } = IndustryMaster.search(
              this.props.master,
              request.term
            );
            this.update({ groups });
            response(list);
          },
        });
        for (const id of props.data.getCheckedGroup(props.master)) {
          this.$(`[data-group="${id}"].accordion_heading`).classList.remove(
            "is-hide"
          );
          this.$(`[data-group="${id}"].accordion_body`).style.display = "block";
        }
      },
      onSearchIndustries() {
        const searchWord = this.$('[name="searchWord"]').value;
        if (searchWord === "") {
          di.toast.push("検索内容が入力されていません", "negative");
          return;
        }
        const { groups } = IndustryMaster.search(this.props.master, searchWord);
        this.update({ searchWord, groups, searchModalIsOpen: true });
      },
      onCheckGroup(e) {
        for (const group of this.props.master) {
          if (group.id == e.target.value) {
            for (const industry of group.list) {
              this.props.data.update({
                id: industry.id,
                checked: e.target.checked,
              });
            }
            break;
          }
        }
        this.props.onUpdate(this.props.data);
      },
      onCheckIndustry(e) {
        this.props.data.update({
          id: e.target.value,
          checked: e.target.checked,
        });
        this.props.onUpdate(this.props.data);
      },
      onTextarea(e, id) {
        this.props.data.update({ id, memo: e.target.value });
        this.props.onUpdate(this.props.data);
      },
      async onSubmit(e) {
        if (this.props.onSubmit()) {
          this.update({ searchModalIsOpen: false });
        }
      },
    };
  </script>
</industries>
